const isBetslipValid = (selectedBet, legs)=> {
  const _legs = legs?.filter(e=>e && e.length > 0);
  
  if (_legs.length !== selectedBet?.legSize ) {
    return false;
  }

  return (_legs.every(e => e.length >= (selectedBet.minHorseSelectCount || 1) ));
};

const isBetSlipEmpty = legs=> {
  const _legs = legs?.filter(e=>e);

  return !_legs.some(e => e.length > 0 );
};

export  { isBetslipValid, isBetSlipEmpty };